export default __webpack_public_path__ + "static/media/logo.cc312c25.svg";